<template>
  <div class="statBox">   
    </div>
</template>

<script>
import { reqStat } from '@/api/lotteryCommon.js'

export default {
    name: 'navBar',
    data () {
        return {
            trackAction: {
                id: null,
                title: '', //活动名称
                pageTitle: '', //页面名称
                pageUrl: '' //页面URL
            }
        }
    },
    props: {
        actId: { type: Number, default: 0 },
        actTitle: { type: String, default: '' },
        from: { type: Number, default: 0 } // 1电脑端，2微信端，3纵览新闻客户端，4河北日报客户端，5H5端 
    },
    computed: {
    
    },
    created () {
        
    },
    mounted () {        

        if(this.actId) {
            this.visitStat();
            //河北日报埋点
            if(this.from == 4) {
                this.trackAction.id = this.actId;
                this.trackAction.title = this.actTitle;
                this.trackAction.pageTitle = document.title;
                this.trackAction.pageUrl = window.location.href;
                console.log('trackAction==', this.trackAction);
                this.initAplusTrack();
            }
        } else {
            console.error("统计失败！");
        }        
    },
    methods: {
        visitStat(){      
        // 1电脑端，2微信端，3纵览新闻客户端，4河北日报客户端，5H5端
         reqStat({lotteryid:this.actId, from:this.from}).then(res => { 
            if(res.code==200) {       
                console.log('stat res', res);        
            } else {
                console.log('stat res', res);  
            }
        }).catch(err => {        
           console.log('stat err', err);
        })        
       },
        // 初始化阿里云 QT 埋点 SDK 并上报手动 PV
        initAplusTrack(){
            const w = window;
            const d = document;
            const q = 'aplus_queue';
            w[q] = w[q] || [];

            const f = d.getElementsByTagName('script')[0];
            const j = d.createElement('script');
            j.async = true;
            j.id = 'beacon-aplus';
            j.src = 'https://o.alicdn.com/QTSDK/quicktracking-sdk/qt_web.umd.js';
            f.parentNode.insertBefore(j, f);

            const queue = w[q];
            // 1. 必填基础配置
            queue.push({
                action: 'aplus.setMetaInfo',
                arguments: ['appKey', 'un4vgafw2pazdwfnpcn10kum']
            });
            queue.push({
                action: 'aplus.setMetaInfo',
                arguments: ['trackDomain', 'https://mediadata.xuexi.cn:8443/']
            });
            // 手动 PV 模式：PV 完全由业务代码通过 aplus.sendPV 上报
            queue.push({ action: 'aplus.setMetaInfo', arguments: ['aplus-waiting', 'MAN'] });
            queue.push({ action: 'aplus.autoTrack', arguments: ['click'] });

            this.trackArticleLiveView(this.trackAction);
        },
        // 手动 PV 上报
        trackArticleLiveView(action = {}, options = {}) {
            if (typeof window === 'undefined') return;
            const queue = window.aplus_queue;
            if (!queue || typeof queue.push !== 'function') return;

            try {
                queue.push({
                    action: 'aplus.sendPV',
                    arguments: [
                        { is_auto: false },
                        {
                            page_code: 'home_pg',
                            page_name: 'home_pg',
                            event_type: 'pageview',
                            event_code: 'home_pg',
                            current_channel_name: '活动', //固定值（活动类）
                            current_page_name: action.title || '', //当前活动名称
                            current_page_id: 'home_pg', //固定值（活动类）                           
                        }
                    ]
                });
            } catch (e) {
                console.error('trackArticlePageView error', e);
            }
        }
    }
}
</script>

<style lang="scss" scoped> 
</style>